import { trackingPageSettingsSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import * as z from "zod";

export const updateTrackingPageSettings = {
  name: "updateTrackingPageSettings" as const,
  input: trackingPageSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
